import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=6d3eb7d6"
import script from "./RedefinirSenha.vue?vue&type=script&lang=ts"
export * from "./RedefinirSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports